import { Controller } from 'react-hook-form'
import PatientFormField from '../PatientFormField'
import { shouldDirty } from '../PatientIdentity/_utils/_utils'
import { NO, YES, useFormContextPatient } from '../_utils'

const LtDiseases = () => {
    const { control, setValue } = useFormContextPatient()

    return (
        <Controller
            control={control}
            name="hasLtDiseases"
            render={({ field, fieldState: { error } }) => {
                const isSet = field.value === true || field.value === false
                let selectValue: 'YES' | 'NO' | undefined
                let label: string | undefined
                if (isSet) {
                    selectValue = field.value ? 'YES' : 'NO'
                    label = field.value ? YES : NO
                }

                return (
                    <PatientFormField<'YES' | 'NO'>
                        variant="select"
                        type="default"
                        label="Le patient a-t-il une ou plusieurs ALD ?"
                        name={field.name}
                        status={{
                            error,
                            valid: isSet,
                            warning: !isSet,
                        }}
                        required
                        dataCyScope="PatientField"
                        renderLabel={() => label}
                        warningMessage={!isSet ? 'Cette information n’a pas encore été complétée' : undefined}
                        clearable={false}
                        value={selectValue}
                        onChange={(e) => {
                            if (e === 'YES') {
                                setValue('hasLtDiseases', true, shouldDirty)
                            } else if (e === 'NO') {
                                setValue('hasLtDiseases', false, shouldDirty)
                            }
                        }}
                        options={[
                            { label: YES, value: 'YES' },
                            { label: NO, value: 'NO' },
                        ]}
                    />
                )
            }}
        />
    )
}

export default LtDiseases
